export default "__VITE_ASSET__c517d995__"